import { render, staticRenderFns } from "./createQuoteStep2.vue?vue&type=template&id=bd78241a&scoped=true&"
import script from "./createQuoteStep2.vue?vue&type=script&lang=js&"
export * from "./createQuoteStep2.vue?vue&type=script&lang=js&"
import style0 from "./createQuoteStep2.vue?vue&type=style&index=0&id=bd78241a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd78241a",
  null
  
)

export default component.exports